import React, { Fragment } from "react";
import icons from "./icons/icons.json";

// if color is passed then it is fixed
// if no color is passed then can change the <svg> fill in the CSS
const Svg = ({ icon, color, size, className = "" }) => {
  const iconColor = color ? icons[icon].replace(/{{color}}/g, color) : icons[icon];

  return (
    <Fragment>
      {size ? (
        <Fragment>
          <span aria-hidden="true">
            <span className={`absolute ${className}`}>
              <div
                dangerouslySetInnerHTML={{ __html: iconColor }}
                style={{ height: size, width: size }}
              />
            </span>
            <div
              style={{
                height: size,
                width: size,
                display: "inline-block",
                visibility: "hidden",
              }}>
              &nbsp;
            </div>
          </span>
        </Fragment>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: iconColor }} aria-hidden="true" />
      )}
    </Fragment>
  );
};

export default Svg;
